<template>
   <div class="contain " style="max-height:400px;">
      <v-card :class="{card:true,mobile:isMobile}">
         <img
             class="clo"
             @click="closeDialog"
             :src="$vuetify.theme.dark?darkcloseIcon:closeIcon"
             alt=""
         />
         <div class="bid d-flex flex-column">
            <span v-text="card.bidName" class="name mb-3" :class="{darkFont:$vuetify.theme.dark }"></span>
            <div class="flex-start-center d-flex flex-row" style="align-items: center;">
               <div class="pt-1 mr-2">
                  <!-- <v-img :src="$walletIcon" alt="logo" width="22px" height="22px"/> -->
               </div>
               <span class="count" style="line-height:22px;" v-text="card.bidCount"></span>
            </div>
         </div>
         <div class="list ">
            <div class="title mb-6 " :class="{darkFont:$vuetify.theme.dark }">{{$t('popupSaletotalSalesStatistics')}}</div>
            <div class="list_cont d-flex flex-row ">
               <div class="col d-flex flex-column ml-3">
                  <div class="row" :class="{darkFont:$vuetify.theme.dark }">{{$t('popupSaletotalTotalRelease')}}: {{totalInfo.totalInventory}}</div>
                  <div class="row " :class="{darkFont:$vuetify.theme.dark }">{{$t('popupSaletotalSold')}}: {{SoldTotal}}</div>
             
               </div>
               <div class="col d-flex flex-column ml-3">
                <div class="row mt-n5" :class="{darkFont:$vuetify.theme.dark }">{{$t('popupSaletotalInStock')}}: {{totalInfo.amount}}</div>
                   <div class="row " :class="{darkFont:$vuetify.theme.dark }">{{$t('popupSaletotalLikes')}}: {{totalInfo.likeCount}}</div> 
               </div>
            </div>
         </div>
   <div class="line" :class="{darkLine:$vuetify.theme.dark }"></div>
          <div class="totalIncome">
        <div class="title" :class="{darkFont:$vuetify.theme.dark }" v-if="aviIris>0 || aviAtom>0 || aviUptick>0 ">{{$t('totalIncome')}}</div>
        <div class="incoList d-flex flex-column">
          <div class="d-flex justify-space-between iconItem" v-if="aviIris>0">
            <div class="d-flex flex-row">
              <v-img
                :src="require('@/assets/icons/chain_iris_w' + '.png')"
                width="22px"
                height="22px"
              />
              <div class="coinName">IRIS</div>
            </div> 
            <div class="iconBalance">{{aviIris}}</div>
          </div>
          <div class="d-flex justify-space-between iconItem" v-if="aviAtom>0">
            <div class="d-flex flex-row">
              <v-img
                :src="require('@/assets/icons/chain_atom_w' + '.png')"
                width="22px"
                height="22px"
              />
              <div class="coinName">ATOM</div>
            </div>
            <div class="iconBalance">{{aviAtom}}</div>
          </div>
          <div class="d-flex justify-space-between iconItem"  v-if="aviUptick>0">
            <div class="d-flex flex-row">
              <v-img
                :src="require('@/assets/icons/chain_uptick_w' + '.png')"
                width="22px"
                height="22px"
              />
              <div class="coinName" :class="{darkFont:$vuetify.theme.dark }">UPTICK</div>
            </div>
            <div class="iconBalance" :class="{darkFont:$vuetify.theme.dark }">{{aviUptick}}</div>
          </div>
        </div>
      </div>
<div class="line1" :class="{darkLine1:$vuetify.theme.dark }"  v-if="aviIris>0 || aviAtom>0 || aviUptick>0 "></div>
         <div class="table  mb-4 mt-4">
            <div class="d-flex flex-row justify-space-between">
               <div class="title" :class="{darkFont:$vuetify.theme.dark }">{{$t('popupSaletotalOrders')}}</div>
                <img
                  src="@/assets/icons/icon_message_all.png"
                  class="icon"
                  style="width: 30px; height: 30px;  "
                  @click="messageAllClick"
                  v-if="orderlist.length>0"
               />
            </div>
            
            <div class="orderlist">
               <div 
                    class="itm mb-1 d-flex flex-row justify-space-between px-2" :class="{somberBackground:$vuetify.theme.dark }"
                    v-for="i in orderlist"
                    :key="i.id"
               >
                  <div class="d-flex flex-row justify-space-around mt-2">
                     <Avatar :size="30"  :hash="i.recipientPhoto" :did="i.recipient" :grade="i.recipientGrade" imgType="smallv"/>
                     <span class="ml-2 mt-2 name item_font" :class="{darkFont:$vuetify.theme.dark }">{{ i.recipientName }}</span>
                  </div>
                  <div class="price" :class="{darkFont:$vuetify.theme.dark }">{{ i.payPrice }} {{i.payTokenType}}</div>
                  <div class="time ml-2" :class="{darkFont:$vuetify.theme.dark }" :title="i.createTime | didfilter">{{ i.createTime | didfilter }}</div>
                  <!-- <img
                      class="mt-3 ml-2 ml-lg-6"
                      width="25px"
                      height="24px"
                      :src="message"
                      alt=""
                      @click="msgBtn(i)"
                  /> -->
               </div>
            </div>
         </div>
      </v-card>
      <div v-if="openmsg" style="position: fixed; right: 20px; bottom: 20px; z-index: 99;">
         <message @getOpen="OpenMsg" v-if="openmsg" :currfriend="currfriend"></message>
      </div>
      <div v-if="openmsg_group" style="position: fixed; right: 20px; bottom: 20px; z-index: 99;">
         <message-group @getOpen="OpenMsg_group" v-if="openmsg_group" :currfriend="currfriend_group"></message-group>
      </div>
      <uToast ref="toast"></uToast>
   </div>
</template>

<script>
  import message from "@/assets/icons/btn_message.png";
  // import countLogo from "@/assets/icons/chain_iris_w.png";
  import Message from "./message";
  import MessageGroup from "./messageGroup";
  import api from "@/api";
  import Avatar from "@/components/avatar/index.vue"

  export default {
    components: { Avatar, Message, MessageGroup },
    data: () => ({
      message,
      // countLogo,
      open: true,
      openmsg: false,
      openmsg_group: false,
      card: {
        bidName: "",
        bidCount: ""
      },
      orderlist: [],
      totalInfo: {},
      pageNumber: 1,
      pageSize: 400,
      totalPage: false,
      currfriend:{},
      currfriend_group:{},
      SoldTotal:'',
       aviIris:0,
                closeIcon:require('@/assets/btn_close.png'),
         darkcloseIcon:require('@/assets/darkimage/btn_close1.png'),
   aviAtom:0,
   aviUptick:0
    }),
    props: {
       pageData: {
          type: Object
       },
      address: {
        type: String
      },
      id: {
        type: Number
      },
	  name: {
	    type: String
	  },
	  minPrice: {
	    type: String
	  },
    },
    computed: {
      isMobile: function() {
        return this.$vuetify.breakpoint.mobile;
      }
    },
    filters: {
      didfilter: function(value) {
        let date = new Date(value);
        let Y = date.getFullYear() + " ";
        let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "/";
        let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "/";
        let h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
        let m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
        let s = (date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds());
        let strDate = M + D + Y + h + m + s;
        return strDate;
      }
    },
    mounted() {
     
      this.getList();
      this.getOrderHistory();
	  this.card.bidName=this.name
	  if(this.minPrice!=undefined){
		  this.card.bidCount=this.minPrice
	  }

    },
    methods: {
       async getOrderHistory(){
          let params = {
          nftId: this.pageData.nftId,
         
        };
        let res = await api.home.orderHistory(params);
        res.data.list.forEach((v) => {
		
			if (!v.recipientName) {
            if(!v.recipient){
               v.recipientName = '—'
            }else{
               v.recipientName = v.recipient.substr(0, 6)+"..."+v.recipient.substr(-6);
            }
			  
			}
			
		});
        this.orderlist = res.data.list;

       },
      async getList() {
        let params = {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          nftId: this.pageData.nftId,
          tokenAddress: this.pageData.nftAddress
        };
        let res = await api.home.orderStatements(params);
        this.totalInfo = res.data;
        this.SoldTotal = this.totalInfo.assetExtension.totalInventory - this.totalInfo.amount
   //        aviIris:0,
   // aviAtom:0,
   // aviUptick:0
   this.aviIris = this.totalInfo.assetExtension.irisTotalPrice
   this.aviAtom = this.totalInfo.assetExtension.atomTotalPrice
   this.aviUptick = this.totalInfo.assetExtension.uptickTotalPrice
		
      },
      onScroll(e) {
        const { scrollTop, clientHeight, scrollHeight } =
          e.target.scrollingElement;
        if (
          scrollTop + clientHeight === scrollHeight &&
          this.totalPage > this.pageNumber
        ) {
          this.getList();
        }
      },
      closeDialog() {
        this.open = false;
        this.$emit("getOpen", this.open);
      },
      msgBtn(i) {
        if(i.assetOwner == this.$store.state.did) {
           this.$refs.toast.show("error", "leave Error", 1000);
           return;
        }
        this.currfriend.fansAddress = i.assetOwner;
        this.currfriend.fansName = i.issuerName;
        this.openmsg_group = false;
        this.openmsg = true;
      },
      OpenMsg(e) {
        this.openmsg = e;
      },
      messageAllClick() {
        this.currfriend_group.group = 1;
        this.currfriend_group.fansAddress = this.pageData.nftAddress;
        this.currfriend_group.fansName = this.$t("notice_group_leavemsg");
        this.currfriend_group.nftId = this.pageData.nftId
        this.openmsg = false;
        this.openmsg_group = true;
      },
      OpenMsg_group(e) {
        this.openmsg_group = e;
      },
    }
  };
</script>

<style lang="scss" scoped>
   .card {
      display: flex;
      flex-direction: column;
      padding: 0 50px;
      min-height: 600px;
      width: 660px;
      //width: 100%;

      .clo {
         position: absolute;
         right: 10px;
         top: 10px;
         width: 30px;
         height: 31px;
         border-radius: 50%;
         margin-right: 0;
         cursor: pointer;
      }

      .bid {
         margin: 16px 0 50px;

         .name {
            font-weight: bold;;
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #270645;
         }

         .count {
            font-weight: bold;;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #270645;
         }
      }

      .list {
         .title {
            font-weight: bold;;
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #270645;
            margin-top:-60px;
         }

         .list_cont {
             height: 40px;
             margin-bottom: 10px;

            .col {
               width: 50%;
               padding: 0;
               text-align: left;

               .row {
                  font-family: Helvetica;
                  font-size: 13px;
                  font-weight: normal;
                  font-stretch: normal;
                  letter-spacing: 0px;
                  color: #270645;
                  vertical-align: middle;
               }
            }
         }
      }
       .line {
    border: solid 1px #e3e3e3;
  
  }
  .darkLine{
      border: solid 1px #272727;
  }
  .darkLine1{
      border: solid 1px #272727 !important;
  }
  .line1 {
    border: solid 1px #e3e3e3;
    margin-top: 15px;
  }
       .totalIncome {
    .title {
      font-family: Helvetica !important;
      font-size: 20px !important;
      font-weight: bold;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #270645;
      margin-top: 10px;
    }
    .incoList {
      .iconItem {
        margin-top: 10px;
      }
      .coinName{
          font-family: Helvetica !important;
      font-size: 13px !important;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #270645;
      margin-top: 3px;
      }
    }
  }

      .table {
         .title {
            font-weight: bold;;
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #270645;
         }

         .orderlist {
            width: 100%;
            height: 263px;
            overflow: hidden;
            overflow-y: auto;

            .itm {
               height: 51px;
               box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.09);
               border-radius: 5px;
               margin: 5px;

               .item_font {
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  width: 60px;
               }

               .name {
                  font-family: Helvetica;
                  font-size: 13px;
                  font-weight: normal;
                  font-stretch: normal;
                  letter-spacing: 0px;
                  color: #270645;
               }

               .price {
                  font-weight: bold;;
                  font-size: 13px;
                  font-weight: bold;
                  font-stretch: normal;
                  letter-spacing: 0px;
                  line-height: 50px;
                  color: #270645;
               }

               .time {
                  font-family: Helvetica;
                  font-size: 13px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 50px;
                  letter-spacing: 0px;
                  color: #270645;
               }

               img {
                  display: inline-block;
                  vertical-align: middle;
               }
            }
         }
      }

      &.mobile {
         .table {
            .orderlist {
               width: 100%;

               .itm {
                  .price {
                     min-width: 50px;
                  }

                  .time {
                     text-overflow: ellipsis;
                     white-space: nowrap;
                     overflow: hidden;
                     width: 40px;
                  }

                  .item_font {
                     text-overflow: ellipsis;
                     white-space: nowrap;
                     overflow: hidden;
                     width: 30px;
                  }
               }

            }
         }
      }
   }
</style>
